"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NavbarLink = props => {
  const {
    activeLinks,
    label,
    openInNewTab,
    to
  } = props;
  const classes = (0, _styles.useStyles)();
  const location = (0, _reactRouterDom.useLocation)();
  const isActive = () => {
    if (!activeLinks) {
      return false;
    }
    return activeLinks.find(link => location.pathname.includes(link));
  };
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    children: label,
    to: to,
    isActive: isActive,
    target: openInNewTab ? "_blank" : "",
    rel: openInNewTab ? "noreferrer noopener" : "",
    className: classes.navLink,
    activeClassName: classes.navLinkActive
  });
};
NavbarLink.propTypes = {
  activeLinks: _propTypes.default.arrayOf(_propTypes.default.string),
  label: _propTypes.default.string,
  openInNewTab: _propTypes.default.bool,
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
};
var _default = exports.default = NavbarLink;